function setHeaderHeight() {
	const header = document.querySelector('header');
	if (!header) return;

	const update = () => {
		const height = header.offsetHeight;
		document.documentElement.style.setProperty('--fixed-header-height', `${height}px`);
	};

	update();

	const observer = new ResizeObserver(update);
	observer.observe(header);
}

export {setHeaderHeight};
